
import { mapState } from "vuex";
import ClickOutside from "vue-click-outside";

export default {
  directives: { ClickOutside },

  props: {
    name: { type: String, required: true },
    image: { type: Object, default: () => {} },
    colour: { type: String, default: "" },
  },

  data: () => ({ showUnavailableModal: false }),

  computed: {
    ...mapState("bedbuilder", [
      "activeOption",
      "activeOptions",
      "availableOptions",
    ]),
    selectedOptionValue() {
      return this.selectedOptions[this.activeOption];
    },
    imgProps() {
      return {
        src: this.image.url,
        alt: this.image.alt,
        height: 95,
        width: 95,
        provider: "ipx",
      };
    },
    selectedOptions() {
      const options = Object.entries(this.$bedbuilder.defaultOptions);
      const validOptions = options.filter(
        ([name]) => this.$route.query?.[name]
      );

      return validOptions.length === options.length
        ? this.$route.query
        : this.$bedbuilder.defaultOptions;
    },
  },

  mounted() {
    // prevent click outside event with popupItem.
    this.popupItem = this.$el;
  },

  methods: {
    handleSelection() {
      if (this.selectedOptionValue == this.name) {
        return;
      }
      const query = {
        ...this.activeOptions,
        [this.activeOption]: this.name,
      };
      if (this.areOptionsChanged(query)) {
        return this.$router.push({ query });
      }
      this.$emit("select", this.name);
      this.showUnavailableModal = true;
      this.$store.dispatch("bedbuilder/openBedbuilderOptionsChange");
    },
    handleOutsideClick() {
      this.showUnavailableModal = false;
      this.$store.dispatch("bedbuilder/openBedbuilderOptionsChange");
    },
    areOptionsChanged(options) {
      const { Material, Colour, Base, Headboard } = options;
      return (
        this.availableOptions[Material]?.[Colour]?.Base.has(Base) &&
        this.availableOptions[Material][Colour].Headboard.has(Headboard)
      );
    },
  },
};
